<template>
  <div v-if="isVisible" class="header-component">
    <div class="first-div">
      <div class="icon-container">
        <ion-icon name="grid-outline"></ion-icon>
      </div>
      <div class="text-content">
        <div class="sub-text">{{ $t("O dashboard está de cara nova!") }}</div>
        <div class="main-text">{{ $t("Novidade para você, gestor!") }}</div>
      </div>
    </div>
    <div class="second-div">
      <button class="view-button" @click="redirectToV2('pt', 'dashboard')">{{ $t("Visualizar novidade") }}</button>
      <button class="close-button" @click="closeBanner">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>
  </div>
</template>

<script>
import { UTIL_SERVICE } from '../../../utils';

export default {
  name: 'NewInfoBanner',
  data() {
    return {
      isVisible: true
    }
  },
  methods: {
    closeBanner() {
      this.isVisible = false
    },
    redirectToV2(language, page) {
      localStorage.setItem('marq_v2_redirect_preference', 'true');
      UTIL_SERVICE.checkLocationAndRedirectToV2(language, page);
    }
  }
}
</script>

<style scoped>
.header-component {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid #A7BFFD;
  background: #EDF2FE;
  box-shadow: 0px 2px 6px -1px rgba(0, 0, 0, 0.08);
  padding: 16px;
  margin-bottom: 24px;
}

.first-div {
  display: flex;
  align-items: center;
  gap: 12px;
}

.icon-container {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid #FFF;
  background: linear-gradient(180deg, #6792FF 0%, #1B59F8 100%);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.07);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-container ion-icon {
  color: white;
  font-size: 16px;
}

.text-content {
  display: flex;
  gap: 2px;
}

.sub-text {
  color: var(--Text-text-head, #3A424E);
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125.303%;
}

.main-text {
  color: var(--Primary-primary-main, #1B59F8);
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125.303%;
}

.second-div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.view-button {
  display: flex;
  padding: 4px 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  border: 1px solid var(--Primary-primary-main, #1B59F8);
  background: var(--Primary-primary-main, #1B59F8);
  box-shadow: 0px -2px 2px 0px #0632A3 inset, 1px 1px 1px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 2px #4D7FFF inset;
  color: white;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}

.close-button ion-icon {
  color: var(--Text-text-head, #3A424E);
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/vue/views/components/NewInfoBanner.vue